module.exports = __webpack_public_path__ + "img/tariff-selection-bg.ac78ef5.webp";